import type { FeatureBlockContent, HeroContent } from '../types';
import {
  businessClosing as businessClosingEn,
  businessFaq as businessFaqEn,
  businessBulkPayments as businessBulkPaymentsEn,
  businessGlobalTeam as businessGlobalTeamEn,
  businessHero as businessHeroEn,
  businessInvoices as businessInvoicesEn,
  businessPaths as businessPathsEn,
  businessPayTeam as businessPayTeamEn,
  businessReceive as businessReceiveEn,
  businessSavingsCalculator as businessSavingsCalculatorEn,
  businessTrust as businessTrustEn,
} from '../business';

export const businessHero: HeroContent = {
  ...businessHeroEn,
  title: 'nroll من nsave: رواتب دولية برسوم تحويل $0',
  cta: { ...businessHeroEn.cta, label: 'قدّم لدفع الرواتب' },
  secondaryCta: { ...businessHeroEn.secondaryCta!, label: 'اطلب عرض توضيحي' },
  ctaDetail: 'رسوم تقديم بقيمة 200 دولار. تطبق شروط وأهلية استرداد الرسوم.',
  ctaNote: {
    text: 'محتاج حساب أعمال عام؟',
    link: { ...businessHeroEn.ctaNote!.link, label: 'انضم لقائمة الانتظار.' },
  },
  image: {
    ...businessHeroEn.image,
    alt: 'لوحة تحكم nsave للشركات وبتعرض رصيد بالدولار والمعاملات على شاشة مكتب',
  },
};

export const businessTrust: typeof businessTrustEn = {
  ...businessTrustEn,
  title: 'حساب رواتب مصمم للفرق الدولية',
  body: 'موّل حساب واحد، وادفع لفريقك الدولي، وخلي الموظفين يستلموا رواتبهم في حساباتهم على nsave.',
  link: { ...businessTrustEn.link!, label: 'شوف إزاي بتشتغل' },
};

export const businessPaths: typeof businessPathsEn = {
  title: 'بتدور على حساب أعمال عام بدلًا من كده؟',
  items: [
    {
      ...businessPathsEn.items[0],
      title: 'انضم لقائمة انتظار حسابات الأعمال',
      description:
        'طلبات حسابات الأعمال العامة متوقفة حاليًا بينما نعمل على تحسين المنتج. انضم لقائمة الانتظار للحصول على التحديثات والوصول المبكر عند إعادة فتح التقديم.',
      cta: { ...businessPathsEn.items[0].cta, label: 'انضم لقائمة انتظار حسابات الأعمال' },
    },
  ],
};

export const businessReceive: FeatureBlockContent = {
  ...businessReceiveEn,
  title: 'قلّل تكلفة الرواتب الدولية',
  description: 'موّل الحساب، وادفع، واستلم في ثلاث خطوات بسيطة.',
  rows: [
    {
      ...businessReceiveEn.rows[0],
      title: '1. موّل حساب الرواتب',
      description: 'أضف أموال الرواتب لحساب nsave للأعمال قبل موعد دفع الرواتب.',
    },
    {
      ...businessReceiveEn.rows[1],
      title: '2. ادفع لموظفينك',
      description:
        'فريقك يفتح حساب nsave مجاني في دقائق باستخدام الإيميل، وبعدها تدفع لكل موظف من حساب واحد.',
    },
    {
      ...businessReceiveEn.rows[2],
      title: '3. فريقك يستلم الراتب',
      description: 'تحويلات الرواتب بتوصل فورًا لحسابات موظفينك على nsave برسوم تحويل $0 من nsave.',
    },
  ],
};

export const businessSavingsCalculator: typeof businessSavingsCalculatorEn = {
  title: 'احسب التوفير في رسوم تحويل الرواتب',
  description:
    'اكتب عدد موظفينك والرسوم اللي بتدفعها حاليًا لكل تحويل عشان تقدّر التوفير مع رسوم تحويل $0 من nsave.',
  employeesLabel: 'عدد الموظفين في كل دفعة',
  feeLabel: 'رسومك الحالية لكل تحويل بالدولار',
  currentCostLabel: 'تكلفة التحويل الحالية',
  nsaveCostLabel: 'تكلفة التحويل مع nsave',
  savingsLabel: 'التوفير المتوقع:',
  perRunLabel: 'لكل دفعة رواتب',
};

export const businessPayTeam: FeatureBlockContent = {
  ...businessPayTeamEn,
  title: 'تحويلات رواتب فورية مجانًا',
  description: 'جزء أكبر من كل دفعة رواتب بيروح لموظفينك بدلًا من مزودي خدمات الدفع.',
  rows: [
    {
      ...businessPayTeamEn.rows[0],
      title: 'رسوم تحويل $0',
      description: 'ادفع للموظفين من غير رسوم nsave على التحويلات بين حسابات nsave.',
    },
    {
      ...businessPayTeamEn.rows[1],
      title: 'اشتراك شهري للرواتب $0',
      description: 'شغّل الرواتب من غير اشتراك شهري متكرر في nsave.',
    },
    {
      ...businessPayTeamEn.rows[2],
      title: 'تسوية فورية',
      description: 'الموظفين بيستلموا دفعات الرواتب فورًا في حساباتهم على nsave.',
    },
  ],
};

export const businessGlobalTeam: FeatureBlockContent = {
  ...businessGlobalTeamEn,
  title: 'حساب رواتب واحد لفريقك العالمي',
  rows: [
    {
      ...businessGlobalTeamEn.rows[0],
      title: 'ادعم فرقك الدولية',
      description: 'ادفع للموظفين والمتعاقدين في الأسواق المدعومة.',
    },
    {
      ...businessGlobalTeamEn.rows[1],
      title: 'ادفع بالإيميل أو ntag',
      description: 'استخدم بيانات موظف بسيطة بدل ما تدخل بيانات بنكية طويلة كل شهر.',
    },
    {
      ...businessGlobalTeamEn.rows[2],
      title: 'مرونة أكتر للموظفين',
      description: 'الموظفين يختاروا يحتفظوا بالراتب أو يصرفوه أو يسحبوه حسب المتاح.',
    },
    {
      ...businessGlobalTeamEn.rows[3],
      title: 'كبّر النظام مع فريقك',
      description: 'أضف الموظفين وخلي بيانات الرواتب في مكان واحد مع نمو فريقك.',
    },
  ],
};

export const businessBulkPayments: FeatureBlockContent = {
  ...businessBulkPaymentsEn,
  title: 'دفعات رواتب جماعية',
  rows: [
    {
      ...businessBulkPaymentsEn.rows[0],
      title: 'ادفع لفريقك كله بخطوات أقل',
      description:
        'ابعت الرواتب لعدة موظفين باستخدام ntag أو الإيميل، وقلل الدفعات اليدوية المتكررة.',
      detail: 'إدارة أقل · دفعات يدوية أقل · رواتب أسهل',
    },
  ],
};

const invoiceRows = [
  ['دفعات رواتب فورية', 'التحويلات بين حسابات nsave بتوصل فورًا عشان فريقك يقبض في ميعاده.'],
  ['مصممة للفرق الدولية', 'ادفع للموظفين والمتعاقدين في أسواق مختلفة من حساب مركزي واحد.'],
  ['إدارة رواتب أقل', 'الدفعات الجماعية وبيانات الموظفين البسيطة بتقلل الشغل اليدوي المتكرر.'],
  [
    'مرونة أكتر للموظفين',
    'البطاقة الافتراضية وميزات الاستثمار متاحة في أسواق محددة، والتوفر بيختلف حسب السوق.',
  ],
] as const;

export const businessInvoices: FeatureBlockContent = {
  ...businessInvoicesEn,
  title: 'ليه الشركات بتستخدم nsave للرواتب',
  rows: businessInvoicesEn.rows.map((row, index) => ({
    ...row,
    title: invoiceRows[index][0],
    description: invoiceRows[index][1],
  })),
};

export const businessClosing: typeof businessClosingEn = {
  ...businessClosingEn,
  title: 'ابدأ nroll لفريقك النهارده',
  body: 'قدّم على حساب رواتب nroll وادفع لفريقك الدولي برسوم تحويل $0 من nsave.',
  image: { ...businessClosingEn.image, alt: 'فريق nsave مع بعض في المكتب' },
  primaryCta: { ...businessClosingEn.primaryCta, label: 'قدّم لدفع الرواتب' },
  secondaryCta: { ...businessClosingEn.secondaryCta, label: 'اطلب عرض توضيحي' },
};

/** Draft only; `localized.ts` serves the approved English FAQ until sign-off. */
export const businessFaq = businessFaqEn;
